import { render } from "./newsec.vue?vue&type=template&id=4ca46833&scoped=true"
import script from "./newsec.vue?vue&type=script&lang=js"
export * from "./newsec.vue?vue&type=script&lang=js"

import "./newsec.vue?vue&type=style&index=0&id=4ca46833&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca46833"]])

export default __exports__